import { OnInit, EventEmitter } from '@angular/core';
import { QuestionType } from 'app/shared/models/question-type';
import { QuestionSet } from 'app/shared/models/question-set';
var QuestionListItemComponent = /** @class */ (function () {
    function QuestionListItemComponent() {
        this.answered = new EventEmitter();
    }
    QuestionListItemComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(QuestionListItemComponent.prototype, "Questions", {
        get: function () {
            if (this.QuestionSet) {
                return this.QuestionSet.questions;
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    // TODO: stephen instead of all these cases would it be better just to dynamically create the components?
    QuestionListItemComponent.prototype.isMultipleChoice = function (type) {
        return type == QuestionType.MultipleChoice;
    };
    QuestionListItemComponent.prototype.isTextbox = function (type) {
        return type == QuestionType.Textbox;
    };
    QuestionListItemComponent.prototype.isChecklist = function (type) {
        return type == QuestionType.Checklist;
    };
    QuestionListItemComponent.prototype.isSingleChoice = function (type) {
        return type == QuestionType.SingleChoice;
    };
    QuestionListItemComponent.prototype.getQuestionLabels = function (question) {
        if (question.CustomLabels && question.CustomLabels.length) {
            return question.CustomLabels;
        }
        else if (this.QuestionSet.labels) {
            return this.QuestionSet.labels;
        }
        else {
            return [];
        }
    };
    QuestionListItemComponent.prototype.handleAnswer = function (question) {
        console.log("Received answer for question: ", question);
        if (this.Questions.every(function (q) { return q.isFilledOut; })) {
            this.answered.emit(this.Questions);
        }
    };
    return QuestionListItemComponent;
}());
export { QuestionListItemComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/question-list-item/question-list-item.component.ts.pre-build-optimizer.js